import { render, staticRenderFns } from "./VolunteerFindNetMatch.vue?vue&type=template&id=5edfb8da"
import script from "./VolunteerFindNetMatch.vue?vue&type=script&lang=ts"
export * from "./VolunteerFindNetMatch.vue?vue&type=script&lang=ts"
import style0 from "./VolunteerFindNetMatch.vue?vue&type=style&index=0&id=5edfb8da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports